// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/tailwindcss/components.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/tailwindcss/utilities.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import "tailwindcss/base";*/
`, "",{"version":3,"sources":["webpack://./src/assets/style/tailwind.css"],"names":[],"mappings":"AAAA,8BAA8B","sourcesContent":["/*@import \"tailwindcss/base\";*/\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
